import { useSyncExternalStore } from 'react';

export type AppTheme = 'light' | 'dark';

function readAppTheme(): AppTheme {
  if (typeof document === 'undefined') return 'light';
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';
}

/** `document.documentElement[data-theme]`와 동기화된 앱 테마 */
export function useAppTheme(): AppTheme {
  return useSyncExternalStore(
    (onStoreChange) => {
      const observer = new MutationObserver(onStoreChange);
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-theme'],
      });
      return () => observer.disconnect();
    },
    readAppTheme,
    () => 'light'
  );
}
